import currency from "currency.js";

import { useFeatureIsOn } from "@/app/featureFlags";
import type { TripBooking } from "@/features/trips/types/types";

import { PriceDetailsCard } from "../bookingFlow/summary/PriceDetailsCard";
import { AdditionalInformationCard } from "../bookingFlow/tripDetails/AdditionalInformationCard";
import { TermsAndConditionsCard } from "../bookingFlow/tripDetails/TermsAndConditionsCard";
import { TripTourPlanCard } from "../bookingFlow/tripDetails/TripTourPlanCard";
import { VisaPermissionsCard } from "../bookingFlow/tripDetails/VisaPermissionsCard";
import { TravellerListCard, TravellerListItem } from "../TravellerListCard";

import { OverviewCard } from "./OverviewCard";

type Props = {
  reservation: TripBooking;
};

export const MyTrip = ({ reservation }: Props) => {
  return (
    <div className="space-y-3">
      <OverviewCard trip={reservation} />
      {reservation.package.itineraries.length > 0 && (
        <TripTourPlanCard itineraries={reservation.package.itineraries} />
      )}
      <TravellerListCard>
        {reservation.travelers.map(
          ({ id, firstName, lastName, passportNumber }) => (
            <TravellerListItem
              key={id}
              name={`${firstName} ${lastName}`}
              additionalData={[
                `${passportNumber.slice(0, 3)}****
                      ${passportNumber.slice(-2)}`,
              ]}
            />
          ),
        )}
      </TravellerListCard>
      <PriceDetailsCard
        basePrice={reservation.price}
        tourPrice={
          useFeatureIsOn("optional-tours") && reservation.includesCityTour
            ? reservation.tourPrice
            : undefined
        }
        baseDiscount={
          currency(reservation.price, {
            precision: 3,
          }).subtract(reservation.discountedPrice).value
        }
        totalPrice={reservation.discountedPrice}
      />
      <VisaPermissionsCard countries={reservation.package.countries} />
      {reservation.package.additionalInformation ? (
        <AdditionalInformationCard
          content={reservation.package.additionalInformation}
        />
      ) : null}
      {reservation.package.termsAndConditions ? (
        <TermsAndConditionsCard
          content={reservation.package.termsAndConditions}
        />
      ) : null}
    </div>
  );
};
